import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Range from '../../dropdownrange/range';
class AccountsWillExpire extends Component {
    constructor(props){
        super(props);
        this.state={
        }
    }
    render() {
        const {daysCount}=this.props;
        return (
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"> 
                        <div class="card card-stats">
                            <div class="card-header" data-background-color="green"><i style={{width:'52px'}} class="fa fa-3x fa-hourglass-end" aria-hidden="true"></i></div>
                            <div class="card-content">
                                <Range applyCallback={(event,range)=>{
                                        event.preventDefault();
                                        this.props.getExpireAccounts(range);
                                        this.props.saveExpireAccountsDaysCount(range);
                                    }}/>
                                <p class="category">Accounts that will expire in {daysCount} days</p>
                                <span class="title" style={{fontSize: '25px'}}>{this.props.adminDashboardexpireAccounts.length}</span>
                            </div>
                            <div class="card-footer text-right">
                                <div class="stats">
                                    <Link class="btn btn-sm btn-primary" to="/adminaccountdetail/accountswillexpiredetails" style={{marginBottom: '0px', marginRight: '0px', padding: '2px 6px'}}>
                                    <i class="fa fa-table"></i>
                                    </Link>
                                </div>
                            </div>                        
                        </div> 
                    </div>                                                        
        );
    }
}

export default AccountsWillExpire;